module.exports = "<div class=\"toast-container\">\r\n    <app-toast *ngFor=\"let toast of toastList\" [toast]=\"toast\"></app-toast>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/app/shared/services/toast/toast-container.component.html
// module id = ../../../../../src/app/shared/services/toast/toast-container.component.html
// module chunks = main